import { render, staticRenderFns } from "./b1.vue?vue&type=template&id=782854a4&scoped=true"
import script from "./b1.vue?vue&type=script&lang=js"
export * from "./b1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782854a4",
  null
  
)

export default component.exports